<ng-template #loading>
  <div class="edp-card-widget card mh-loader">
    <edp-loader [size]="'md'" class="text-center" [position]="'center'"></edp-loader>
  </div>
</ng-template>

<!--  Desktop Widget -->
<ng-container *ngIf="(activeMetersElectricity?.length ||
  activeMetersGas?.length) && contract; else loading">
  <div class="edp-card-widget card desktop" [ngClass]="{'d-flex flex-column h-100': changeMobile}">
    <div class="card-header py-3">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab"
        (navChange)="onNavChange($event)" class="nav">
        <!-- Electricity Tab -->
        <li class="nav-item" [ngbNavItem]="1" *ngIf="!!showTabElectricityActive">
          <a class="nav-link" ngbNavLink>
            {{
            'pt.edp.edponline.edpcontractconsumptionselectricity.contractconsumptionselectricity.eletricidade'
            | translate }}
          </a>


          <ng-template ngbNavContent *ngIf="!simulateElectricity">
            <edp-widget-consumptions-jumbotron
              [contract]="contract"
              [activeMeters]="selectedElectricityMeter"
              [isMultiMeter]="isEletricityMultiMeter">
            </edp-widget-consumptions-jumbotron>
            <edp-widget-consumptions-electricity
              class="h-100 d-flex flex-column"
              [contract]="contract"
              [activeMeters]="selectedElectricityMeter"
              (submitted)="onSubmitted($event)">
            </edp-widget-consumptions-electricity>
            <div *ngIf="isApp" class="how-read-meter">
                <span class="description" [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.voice.difficulty.reading.meter' | translate"></span>
                <a (click)="showHowReadMeter()" [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="{
                  formModal: 'pt.edp.edponline.dashboard.widget.consumptions.voice.guides.you' | translate,
                  interactionName: 'edp-guia-o-no-processo',
                  interactionLocation: 'leituras'
              }"> {{ 'pt.edp.edponline.dashboard.widget.consumptions.voice.guides.you' | translate }}</a>
            </div>
          </ng-template>
          <ng-container *ngIf="!contract.HasContaCerta">
            <ng-template ngbNavContent *ngIf="simulateElectricity">
              <edp-widget-consumptions-simulation
                class="h-100 d-flex flex-column"
                [contract]="contract"
                [activeTab]="'E'"
                [hiddenTabActiveMetersSubmitted]="contract.getType()
                ===
                'dual' ? selectedGasMeter : null"
                [isMultiMeters]="isMultimeters"
                (reloadWidget)="reloadWidget($event)"
                (executeGetMetersOnDestroy)="executeGetMetersOnDestroy($event)">
              </edp-widget-consumptions-simulation>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="contract.HasContaCerta">
            <ng-template ngbNavContent *ngIf="simulateElectricity">
              <edp-widget-consumptions-simulation-conta-certa
                class="h-100 d-flex flex-column"
                [contract]="contract"
                [activeTab]="'E'"
                [hiddenTabActiveMetersSubmitted]="contract.getType()
                ===
                'dual' ? selectedGasMeter : null"
                (reloadWidget)="reloadWidget($event)"></edp-widget-consumptions-simulation-conta-certa>
            </ng-template>
          </ng-container>
        </li>
        <!-- End Electricity Tab -->
        <!-- Gas Tab -->
        <li class="nav-item" [ngbNavItem]="2" *ngIf="contract.HasG">
          <a class="nav-link" ngbNavLink>
            {{
            'pt.edp.edponline.edpcontractconsumptionsgas.contractconsumptionsgas.gas'
            | translate }}
          </a>

          <ng-template ngbNavContent *ngIf="!simulateGas">
            <edp-widget-consumptions-jumbotron
              [contract]="contract"
              [activeMeters]="selectedGasMeter"
              [isMultiMeter]="isGasMultiMeter">
            </edp-widget-consumptions-jumbotron>
            <edp-widget-consumptions-gas
              class="h-100 d-flex flex-column"
              [contract]="contract"
              [activeMeters]="selectedGasMeter"
              (submitted)="onSubmitted($event)">
            </edp-widget-consumptions-gas>
          </ng-template>
          <ng-container *ngIf="!contract.HasContaCerta">
            <ng-template ngbNavContent *ngIf="simulateGas">
              <edp-widget-consumptions-simulation
                class="h-100 d-flex flex-column"
                [contract]="contract"
                [activeTab]="'G'"
                [hiddenTabActiveMetersSubmitted]="contract.getType()
                ===
                'dual' ? selectedElectricityMeter : null"
                (reloadWidget)="reloadWidget($event)"></edp-widget-consumptions-simulation>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="contract.HasContaCerta">
            <ng-template ngbNavContent *ngIf="simulateGas">
              <edp-widget-consumptions-simulation-conta-certa
                class="h-100 d-flex flex-column"
                [contract]="contract"
                [activeTab]="'G'"
                [hiddenTabActiveMetersSubmitted]="contract.getType()
                ===
                'dual' ? selectedElectricityMeter : null"
                (reloadWidget)="reloadWidget($event)"></edp-widget-consumptions-simulation-conta-certa>
            </ng-template>
          </ng-container>
        </li>
        <!-- End Gas Tab -->
      </ul>
      <span class="card-icon">
        <i class="icon-edponline-Bop-021"  aria-hidden="true"></i>
      </span>
    </div>
    <div class="card-body" [ngClass]="{'card-body-no-pdt':
      (activeMetersElectricityId.length && activeMetersElectricityId.length > 1)
      || (activeMetersGasId.length && activeMetersGasId.length > 1)}">

      <edp-filter-picker
          *ngIf="activeTab === 1 && activeMetersElectricityId.length && activeMetersElectricityId.length > 1"
          [label]="labelElectricity"
          [selectedFilter]="selectedElectricityMeterId"
          [filterList]="activeMetersElectricityId"
          [prefixLabel]="'pt.edp.edponline.filter.picker.counter' | translate"
          (filterSelected)="setActiveElectrivityMeter($event)"
          [helperLabel]="'pt.edp.edponline.filter.picker.counter'"
      ></edp-filter-picker>

      <edp-filter-picker
          *ngIf="activeTab === 2 && activeMetersGasId.length && activeMetersGasId.length > 1"
          [label]="labelElectricity"
          [selectedFilter]="selectedGasMeterId"
          [filterList]="activeMetersGasId"
          [prefixLabel]="'pt.edp.edponline.filter.picker.counter' | translate"
          (filterSelected)="setActiveGasMeter($event)"
          [helperLabel]="'pt.edp.edponline.filter.picker.counter'"
      ></edp-filter-picker>

      <div [ngbNavOutlet]="nav"></div>
    </div>
    <!-- only mobile-->
    <div class="card-footer text-center mobile">
      <a (click)="toggleWidget(activeTab)" class="d-block text-link">
        {{ 'ContractBillingFeature.Fechar' | translate }}
        <span class="ml-2">
          <i class="icon-edponline-Bop-073 rotate-180
            font-weight-bold"  aria-hidden="true"></i>
        </span>
      </a>
    </div>
  </div>

  <!--  Mobile Card -->
  <div class="edp-card-widget card mobile" [ngClass]="{'d-none':
    changeMobile}">
    <div class="card-header">
      <span class="card-title">
        {{ 'pt.edp.edponline.pack.contract.readings' | translate }}
      </span>
      <span class="card-icon">
        <i class="icon-edponline-Bop-021"  aria-hidden="true"></i>
      </span>
    </div>
    <div class="card-body">
      <edp-widget-consumptions-jumbotron *ngIf="activeTab === 1"
        [contract]="contract"
        [activeMeters]="selectedElectricityMeter"
        [isMultiMeter]="isEletricityMultiMeter">
      </edp-widget-consumptions-jumbotron>
      <edp-widget-consumptions-jumbotron *ngIf="activeTab === 2"
        [contract]="contract"
        [activeMeters]="selectedGasMeter"
        [isMultiMeter]="isGasMultiMeter">
      </edp-widget-consumptions-jumbotron>
    </div>
    <div class="card-footer text-center">
      <a (click)="toggleWidget(activeTab)" class="text-link">
        <!-- button to send Electricity -->
        <ng-container *ngIf="activeTab === 1">
          <span *ngIf="!selectedElectricityMeter?.updateReadingInTime
            &&
            !selectedElectricityMeter?.updateReadingOutTime">{{
            'ContractReadings.sendreading' | translate
            }}</span>
          <span *ngIf="selectedElectricityMeter?.updateReadingInTime ||
            selectedElectricityMeter?.updateReadingOutTime">{{
            'pt.edp.edponline.dashboard.widget.consumptions.updateConsumptions'
            |
            translate  }}</span>
        </ng-container>
        <!-- button to send Gas -->
        <ng-container *ngIf="activeTab === 2">
          <span *ngIf="!selectedGasMeter?.updateReadingInTime &&
            !selectedGasMeter?.updateReadingOutTime">{{
            'ContractReadings.sendreading' | translate
            }}</span>
          <span *ngIf="selectedGasMeter?.updateReadingInTime ||
            selectedGasMeter?.updateReadingOutTime">{{
            'pt.edp.edponline.dashboard.widget.consumptions.updateConsumptions'
            |
          translate  }}</span>
        </ng-container>

        <span class="ml-2">
          <i class="icon-edponline-Bop-073 font-weight-bold"  aria-hidden="true"></i>
        </span>
      </a>
    </div>
  </div>
</ng-container>
